module.exports = __webpack_public_path__ + "static/media/number_line_bg_green.2c1fbde0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/svg/number_line_bg_green.svg
// module id = 1406
// module chunks = 0